module.exports = __webpack_public_path__ + "static/media/HCMM118.afc11307.jpg";